/// <reference path="../../app.definition.ts" />

import { Serializable } from "./Serializable";

export class FormFieldOption implements Serializable<FormFieldOption> {
    type: string;
    minLength: number;
    maxLength: number;
    legalChars: string;
    minValue: number;
    maxValue: number;
    interval: number;
    listOptions: any;
    scaleLabels: any;
    webType: string;
    regex: string;
    minDate: number;
    maxDate: number;
    valueLabels: any;

    constructor(input?: any) {
        !!input && this.deserialize(input);
    }

    deserialize(input: any) {
        !!input.type && (this.type = input.type);
        !!input.minLength && (this.minLength = parseInt(input.minLength));
        !!input.maxLength && (this.maxLength = parseInt(input.maxLength));
        !!input.legalChars && (this.legalChars = input.legalChars);
        !!input.minValue && (this.minValue = parseFloat(input.minValue));
        !!input.maxValue && (this.maxValue = parseFloat(input.maxValue));
        !!input.interval && (this.interval = parseFloat(input.interval));
        !!input.listOptions && (this.listOptions = JSON.parse(input.listOptions));
        !!input.scaleLabels && (this.scaleLabels = JSON.parse(input.scaleLabels));
        !!input.webType && (this.webType = input.webType);
        !!input.regex && (this.regex = input.regex);
        !!input.minDate && (this.minDate = parseFloat(input.minDate));
        !!input.maxDate && (this.maxDate = parseFloat(input.maxDate));
        !!input.valueLabels && (this.valueLabels = JSON.parse(input.valueLabels));

        return this;
    }
}
